import api from "./api";

export async function getUserSessions(userId) {
  const id = String(userId || "").trim();
  if (!id) {
    throw new Error("userId is verplicht");
  }
  const res = await api.get(`/sessions/user/${id}`);
  return res.data;
}

export async function revokeSessionBySid(sid) {
  const value = String(sid || "").trim();
  if (!value) {
    throw new Error("sid is verplicht");
  }
  const res = await api.post(`/sessions/revoke/${encodeURIComponent(value)}`);
  return res.data;
}

export async function revokeAllSessionsByUserId(userId) {
  const id = String(userId || "").trim();
  if (!id) {
    throw new Error("userId is verplicht");
  }
  const res = await api.post(`/sessions/revoke-all/${encodeURIComponent(id)}`);
  return res.data;
}
